import { UnicodeBlocks } from './unicode-blocks';
import { UnicodeChars } from './unicode-chars';
import { UnicodeNormalizations } from './unicode-normalizations';

export abstract class Unicodes {
  static readonly CHARS = UnicodeChars;
  static readonly BLOCKS = UnicodeBlocks;
  static readonly NORMALIZATIONS = UnicodeNormalizations;

  static readonly DIACRITIC_BLOCK_PROPERTY_PATTERN = new RegExp(
    `\\p{${UnicodeBlocks.DIACRITIC_BLOCK}}`,
    'gu',
  );
}
